module.exports = __webpack_public_path__ + "static/media/careerfounder.c51654fe.png";